import axios from "axios"

export class Budget {
    static store(params = {}) {
        return axios.post(window.apis.orcamento, params)
    }
}
